export default __webpack_public_path__ + "static/media/arrow-right.7f56d3c0.svg";